import React from "react"

import { Label, Tooltip } from "@coval/ui"
import { Info } from "lucide-react"

interface FieldLabelProps {
  children: React.ReactNode
  htmlFor?: string
  /** Forwarded to the inner <Label> so it can be referenced via aria-labelledby. */
  id?: string
  required?: boolean
  /**
   * Optional context shown in an info tooltip next to the label. Useful for
   * explaining arguments tied to third-party services.
   */
  tooltip?: React.ReactNode
}

/**
 * A form field label with an optional required marker and an info tooltip.
 * Renders identically to a plain <Label> when no tooltip is provided.
 */
export const FieldLabel: React.FC<FieldLabelProps> = ({
  children,
  htmlFor,
  id,
  required,
  tooltip,
}) => (
  <div className="flex items-center gap-1.5">
    <Label htmlFor={htmlFor} id={id}>
      {children}
      {required && <span className="text-red-500"> *</span>}
    </Label>
    {tooltip && (
      <Tooltip content={<div className="max-w-xs">{tooltip}</div>} side="right">
        <Info className="w-3.5 h-3.5 text-coval-text-muted" />
      </Tooltip>
    )}
  </div>
)
